import React from 'react';
import ProductCard from '../ProductCardList/ProductCard/ProductCard';
import { SelectableWrapper } from './SelectableWrapper';
export const SelectableProductCard = ({ onSelect, isDisabled, children, isSelected, selectedStyle, dataHook, ...props }) => {
    const handleSelect = () => {
        if (!isDisabled) {
            onSelect();
        }
    };
    return (React.createElement(SelectableWrapper, { dataHook: dataHook, onSelect: handleSelect, isSelected: isSelected, isDisabled: isDisabled, selectedStyle: selectedStyle },
        React.createElement(ProductCard, { ...props }, children)));
};
SelectableProductCard.Tag = ProductCard.Tag;
SelectableProductCard.Header = ProductCard.Header;
SelectableProductCard.Separator = ProductCard.Separator;
SelectableProductCard.FeatureList = ProductCard.FeatureList;
SelectableProductCard.Price = ProductCard.Price;
SelectableProductCard.Content = ProductCard.Content;
//# sourceMappingURL=SelectableProductCard.js.map